"use client";

import { useGetV3TurnkeyRecoveryStatus } from "@/gen/orval/webplatform-v3/endpoints/embedded-wallets/embedded-wallets.gen";
import { useEmbeddedWalletsEnabled } from "@/lib/hooks/flags/use-embedded-wallets-enabled";

// The org's recovery setup as Turnkey holds it, read through our backend so it works before any Turnkey
// session exists. One query shared by the three SMS offer surfaces, the Profile section, and recovery; the SMS
// flows invalidate it after a change. The signer-enroll auto-prompt is mounted layout-wide, so it passes
// `enabled` to suppress the query for viewers who can't use the wallet (avoids a 403 on every page).
export function useRecoveryStatus(options?: { enabled?: boolean }) {
  const ffEnabled = useEmbeddedWalletsEnabled();
  const enabled = (ffEnabled ?? false) && (options?.enabled ?? true);
  return useGetV3TurnkeyRecoveryStatus({ query: { enabled, staleTime: 30_000 } });
}
